import React from 'react';
type Variant = 'primary' | 'secondary' | 'ghost' | 'accent' | 'danger';
type Size = 'sm' | 'md' | 'lg';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  full?: boolean;
}
const variants: Record<Variant, string> = {
  primary: 'bg-green-500 text-white border-green-500 hover:bg-green-600 hover:border-green-600',
  secondary: 'bg-white text-ink border-line hover:bg-canvas',
  ghost: 'bg-transparent text-ink-muted border-transparent hover:bg-canvas hover:text-ink',
  accent: 'bg-purple-500 text-white border-purple-500 hover:bg-purple-600 hover:border-purple-600',
  danger: 'bg-white text-rose-600 border-rose-200 hover:bg-rose-50'
};
const sizes: Record<Size, string> = {
  sm: 'h-8 px-3 text-[13px] gap-1.5',
  md: 'h-10 px-4 text-sm gap-2',
  lg: 'h-12 px-5 text-[15px] gap-2'
};
export function Button({
  variant = 'primary',
  size = 'md',
  full,
  className = '',
  ...rest
}: ButtonProps) {
  return <button {...rest} className={`inline-flex items-center justify-center rounded-lg border font-medium transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-green-300 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${variants[variant]} ${sizes[size]} ${full ? 'w-full' : ''} ${className}`} data-id="element-419" data-mp="johctpf7te8i" />;
}